import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "../Input/Button/ButtonsConstructor";
import { withLocalizationContext } from "../../components";

class LanguagePicker extends Component {
	render({className, style, localizationContext}) {
		const {internationalizer, activeLanguage, setActiveLanguage} = localizationContext;

		return (
			<section className={combineClasses("language-picker", className)} style={style}>
				<ButtonsConstructor
					buttons={internationalizer.getAllRegions().map(region => {
						return {
							icon: this._getIconForRegion(region),
							active: activeLanguage.isRelatedCode(region),
							disabled: activeLanguage.isRelatedCode(region),
							action: () => setActiveLanguage(region),
						}
					})}
					sharedProps={{className: "no-style"}}
				/>
			</section>
		);
	}

	_getIconForRegion(region) {
		switch (region) {
			case "cs":
				return "CZECH";
			case "en":
				return "ENGLISH";
		}
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			translationContext: PropTypes.object,
		}
	}
}

export default withLocalizationContext(LanguagePicker);
